import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 25 2019
 * @author Vojtěch Smolař
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React from 'react';
import { observer, Observer } from 'mobx-react';
import AgGrid from '../../components/tables/AgGrid';
import AgGridWrapper from '../../components/tables/AgGrid/styled/AgGridWrapper';
import Page from '../../components/layout/Page';
import QuerryForm from '../../components/SystemAdmin/QuerryForm';
import ImportsPageStore from '../../shared/stores/system-admin/ImportsPageStore';
import { CommonPageNamesEnum } from '../../shared/localization/PageNamesEnum';

var ImportsPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ImportsPage, _React$Component);

  function ImportsPage() {
    var _this;

    _classCallCheck(this, ImportsPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImportsPage).apply(this, arguments));
    _this.store = new ImportsPageStore(_this.props.match.params.limit, _this.props.match.params.offset, _this.props.history);
    return _this;
  }

  _createClass(ImportsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.store.load();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Page, {
        titleKey: CommonPageNamesEnum.Import,
        loadingState: this.store.loadingState
      }, React.createElement(Observer, null, function () {
        return React.createElement(React.Fragment, null, _this2.renderQuerryForm(), React.createElement(AgGridWrapper, null, React.createElement(AgGrid, {
          gridId: "ImportsPage",
          treeData: true,
          columnDefs: _this2.store.treeColumnDefs,
          rowData: _this2.store.treeRowData,
          onGridReady: _this2.store.onGridReady,
          getDataPath: _this2.store.getDataPath,
          autoGroupColumnDef: _this2.store.autoGroupColumnDef,
          groupDefaultExpanded: 0,
          animateRows: false,
          suppressExcelExport: true,
          suppressCsvExport: true
        })));
      }));
    }
  }, {
    key: "renderQuerryForm",
    value: function renderQuerryForm() {
      return React.createElement(QuerryForm, {
        store: this.store.filterStore,
        submitHandler: this.store.onFilterFormSubmit
      });
    }
  }]);

  return ImportsPage;
}(React.Component);

ImportsPage = __decorate([observer], ImportsPage);
export default ImportsPage;